import { ApplicationConfig,provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { DateAdapter,MAT_DATE_FORMATS,MAT_DATE_LOCALE,MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules,provideRouter,withPreloading } from '@angular/router';
import { SundayFirstDateAdapter } from '@core/providers/sunday-first-date-adapter';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    // Material 22 animates with CSS; this is for ngx-material-timepicker, which still uses Angular animations.
    provideAnimationsAsync(),
    { provide: DateAdapter, useClass: SundayFirstDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
};
